import parseData from '@/utils/parseData'

export default {
  name: 'ClusterCard',
  props: {
    item: {
      type: Object,
      required: true
    },
    workspaceId: {
      type: Number,
      required: true
    },
    contentplanId: {
      type: Number,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    showArticleCheckbox: {
      type: Boolean,
      default: true
    },
    ctaButton: {
      type: String,
      default: 'add-to-favorites'
    },
    ctaButtonLoading: {
      type: Boolean,
      default: false
    },
    dismissLoading: {
      type: Boolean,
      default: false
    },
    highlight: {
      type: Boolean,
      default: false
    },
    showUrl: {
      type: Boolean,
      default: false
    },
    showSearchVolume: {
      type: Boolean,
      default: true
    },
    showRelevance: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    isWritten () {
      const writtenStatuses = ['reviewed', 'shared', 'illustrated', 'edited']
      return writtenStatuses.includes(this.item.status)
    },
    isPublished () {
      return this.item.status === 'published' || this.item.article_url !== null
    },
    isMapped () {
      return this.item.show_in_map
    }
  },
  methods: {
    parseData,
    handleCheckboxClick () {
      this.$emit('checkbox-click', this.item)
    },
    handleAddToMap () {
      this.$emit('add-to-map', this.item)
    },
    handleWrite (item) {
      this.$emit('write-article', item)
    },
    handleDismiss (item) {
      this.$emit('dismiss-article', item)
    }
  }
}
